var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { stringify } from 'qs';
import { getConfig } from '../utils/config';
import apiClient from './apiClient';
const getBaseURL = () => {
    const config = getConfig();
    if (!config) {
        throw Error('config not loaded');
    }
    return config.cashier.baseURL;
};
// FIXME: Deprecated? Can this be removed?
export const login = ({ username, password, refreshToken }) => __awaiter(void 0, void 0, void 0, function* () {
    let dataToSend;
    if (refreshToken) {
        dataToSend = {
            refresh_token: refreshToken,
        };
    }
    else {
        dataToSend = {
            username,
            password,
        };
    }
    const response = yield apiClient.post(`${getBaseURL()}/api/sessions`, dataToSend);
    return response.data;
});
export const updateUser = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.put(`${getBaseURL()}/api/users/self`, params);
    return response.data;
});
export const exchangeCoins = (amount) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.post(`${getBaseURL()}/api/coins/exchange`, {
        amount,
    });
    return response.data;
});
export const getCoinsExchangeRate = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/coins/exchange_rate`);
    return response.data;
});
export const getMessages = (offset = 0, limit = 13) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/messages`, {
        params: {
            offset,
            limit,
        },
    });
    return response.data;
});
export const getMessage = (messageId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/messages/${messageId}`);
    return response.data;
});
export const getUnreadMessagesCount = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/messages/unread_count`);
    return response.data;
});
export const markMessageAsRead = (messageId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.post(`${getBaseURL()}/api/messages/${messageId}/mark_as_read`, {});
    return response.data;
});
export const getUserWallets = (excludeTypes) => __awaiter(void 0, void 0, void 0, function* () {
    const excludeTypesQuery = excludeTypes && excludeTypes.length > 0 ? `?exclude_types=${excludeTypes.join(',')}` : '';
    const response = yield apiClient.get(`${getBaseURL()}/api/users/self/wallets/balance${excludeTypesQuery}`);
    return response.data.wallets;
});
export const getLoyaltyLevels = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/coins/loyalty_levels`);
    return response.data.loyaltyLevels;
});
export const logActivity = (type, details) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.post(`${getBaseURL()}/api/activity`, {
        type,
        details,
    });
    return response.data.success;
});
export const getWatchlist = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/watchlist`);
    return response.data.watchlist;
});
export const addToWatchlist = (symbol) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.post(`${getBaseURL()}/api/watchlist`, {
        symbol,
    });
    return response.data.success;
});
export const removeFromWatchlist = (symbol) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.delete(`${getBaseURL()}/api/watchlist/${symbol}`);
    return response.data.success;
});
export const walletTransactions = (walletId, startDate, endDate) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/users/self/wallets/${walletId}/transactions`, {
        params: {
            startDate,
            endDate,
        },
    });
    return response.data;
});
export const getWallets = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/users/self/wallets`);
    return response.data;
});
export const positionsByWallet = (walletId, startDate, endDate) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/users/self/positions/${walletId}`, {
        params: {
            startDate,
            endDate,
        },
    });
    return response.data;
});
export const getAllInstruments = (statuses) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/users/instruments`, {
        params: statuses && statuses.length > 0 ? { statuses } : undefined,
    });
    return response.data;
});
export const getGreyLabelLogo = (wtreferrer) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/referrers/grey_label/logos`, {
        params: {
            wtreferrer,
        },
    });
    return response.data;
});
export function getVapidKey() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.get(`${getBaseURL()}/api/push_notifications/vapid_key`);
        return response.data.publicVapidKey;
    });
}
export function pushSubscribe(subscription, topic) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield apiClient.post(`${getBaseURL()}/api/push_notifications/subscriptions`, {
            subscription,
            topic,
        });
        return response.data;
    });
}
export function deleteSubscription(endpoint, topic) {
    return __awaiter(this, void 0, void 0, function* () {
        const qs = stringify({ topic, endpoint });
        const response = yield apiClient.delete(`${getBaseURL()}/api/push_notifications/subscriptions?${qs}`);
        return response.data;
    });
}
export function getSubscription(endpoint, topic) {
    return __awaiter(this, void 0, void 0, function* () {
        const qs = stringify({ topic, endpoint });
        const response = yield apiClient.get(`${getBaseURL()}/api/push_notifications/subscriptions?${qs}`);
        return response.data;
    });
}
export const calculateMargin = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get(`${getBaseURL()}/api/users/self/margin/calculate`, {
        params,
    });
    return response.data;
});
